import { render, staticRenderFns } from "./AmeliaFeeWaiver.vue?vue&type=template&id=2beb8bd2"
import script from "./AmeliaFeeWaiver.vue?vue&type=script&lang=js"
export * from "./AmeliaFeeWaiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports